import { savePersonalizeExperienceAction } from "../../../../Actions/LogicActions/MyAccount/PersonalizeExperience/SavePersonalizeExperienceAction";
import { confirmFmlmSearchAction } from "../../../../Actions/UIActions/FmlmSearch/ConfirmFmlmSearchAction";
import { favouriteFmlmLocationAction } from "../../../../Actions/UIActions/Search/FavouriteFmlmLocationAction";
import { favoriteStopAction } from "../../../../Actions/UIActions/Search/FavoriteStopAction";
import { opencloseLocationMap } from "../../../../Actions/UIActions/Search/OpenCloseLocationMap";
import { openOriginDestinationDropdownAction } from "../../../../Actions/UIActions/Search/OpenOriginDestinationDropdownAction";
import { openSubStationDropdownAction } from "../../../../Actions/UIActions/Search/OpenSubStationDropdownAction";
import { selectOriginDestinationAction } from "../../../../Actions/UIActions/Search/SelectOriginDestinationAction";
import { updatedStopsAction } from "../../../../Actions/UIActions/Search/UpdatedStopsAction";
import { ExecutionStatus } from "../../../../core/enum/ExecutionStatus";
import { _eventBus } from "../../../../core/events/EventBus";
import { StepDefinition } from "../../../../core/flows/StepDefinition";
import { StepFlow } from "../../../../core/flows/StepFlow";
import { evtTree } from "../../../../Orchestrator/ConstantTree";
import { fmlmSearchTree } from "../../../../Orchestrator/ConstantTree/FmlmSearch/FmlmSearchTree";
import { ILocation, IUserResponse, SearchStateType } from "../../../../Orchestrator/Types/Index";
import { IConfirmFmlmSearchActionParams } from "../../../../Orchestrator/Types/Interface/ActionParams/ConfirmFmlmSearchActionParams";
import { IFavoriteFmlmLocationActionParams } from "../../../../Orchestrator/Types/Interface/ActionParams/FavouriteFmlmLocationActionParams";
import { IFavoriteStopActionParams } from "../../../../Orchestrator/Types/Interface/ActionParams/FavoriteStopActionParams";
import { LocationPermission, LocationState } from "../../../../Orchestrator/Types/Types/FmlmSearch/FmlmSearchType";
import { SearchContext } from "../Context/SearchContext";

class SelectSearchStopStep extends StepFlow {
  get stepName() {
    return "SelectSearchStop_Step";
  }

  async onEventSetup(): Promise<void> {
    this.registerEventSubscription(
      _eventBus.on<ILocation, void>({
        eventName: evtTree.SearchBar.SelectOrigin.Select,
        handler: async (payload) => {
          let context = this.getCtx<SearchContext>("searchContext")!;
          context.selectedLocation = payload.data!;
          await selectOriginDestinationAction.setParams({ ...context.selectedLocation });
          await selectOriginDestinationAction.execute();

          if (selectOriginDestinationAction.status.executionStatus === ExecutionStatus.SUCCESS) {
            context.searchStateAtom = selectOriginDestinationAction.result!;

            /**
             * This is because to check origin is already select or not
             * If origin is selected then it's redirect to init step to stop selection step for destination automatically.
             */
            if (context.selectedLocation.field === "from") context.isOriginSelected = true;

            context.routeTo = ["SearchStartupInit_Step"];
            this.next();
          }
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<{ data: any }, void>({
        eventName: evtTree.SearchBar.Stops.Updated,
        handler: async (payload) => {
          await updatedStopsAction.setParams(payload.data!);
          await updatedStopsAction.execute();
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<{ dropdownName: string; openDropdowns: any }, void>({
        eventName: evtTree.SearchBar.SubStations.Click,
        handler: (payload) => {
          openSubStationDropdownAction.setParams(payload.data!);
          openSubStationDropdownAction.execute();
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<IFavoriteStopActionParams, void>({
        eventName: evtTree.SearchBar.Favourite.Click,
        handler: async (payload) => {
          favoriteStopAction.setParams(payload.data!);
          await favoriteStopAction.execute()
        }
      })
    )

    this.registerEventSubscription(
      _eventBus.on<{ outsideClick: boolean }, void>({
        eventName: evtTree.SearchBar.SelectOrigin.Click,
        handler: async (payload) => {
          let context = this.getCtx<SearchContext>("searchContext");
          if (context) {
            context.field = "origin";
            context.outsideClick = payload.data?.outsideClick || false;
            if (context.outsideClick) context.isOriginSelected = false;
            openOriginDestinationDropdownAction.setParams({
              field: context.field,
              outsideClick: context.outsideClick,
            });
            await openOriginDestinationDropdownAction.execute();
            if (
              openOriginDestinationDropdownAction.status.executionStatus === ExecutionStatus.SUCCESS
            ) {
              context.listOfStops = openOriginDestinationDropdownAction?.result || [];
              // context.stepRoute = "SearchStartupInit_Step"
              context.routeTo = ["SearchStartupInit_Step"];
              // this.setCtx("choice", ["SearchStartupInit_Step"]);
              this.next();
            }
          }
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<{ outsideClick: boolean }, void>({
        eventName: evtTree.SearchBar.SelectDestination.Click,
        handler: async (payload) => {
          let context = this.getCtx<SearchContext>("searchContext")!;
          context.field = "destination";
          context.outsideClick = payload.data?.outsideClick || false;
          if (context.outsideClick) context.isOriginSelected = false;
          await openOriginDestinationDropdownAction.setParams({
            field: context.field,
            outsideClick: context.outsideClick,
          });
          await openOriginDestinationDropdownAction.execute();

          if (
            openOriginDestinationDropdownAction.status.executionStatus === ExecutionStatus.SUCCESS
          ) {
            context.listOfStops = openOriginDestinationDropdownAction?.result || [];

            this.setCtx("choice", ["SearchStartupInit_Step"]);
            this.next();
          }
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<{ visible: boolean, locationPermission: LocationPermission }, void>({
        eventName: evtTree.SearchBar.LocationMap.Click,
        handler: async (payload) => {
          let context = this.getCtx<SearchContext>("searchContext")!;
          context.locationMapVisible = payload.data?.visible || false;
          context.locationPermission = payload.data?.locationPermission!;
          await opencloseLocationMap.setParams({ isVisible: context.locationMapVisible, locationPermission: context.locationPermission });
          await opencloseLocationMap.execute();
          context.routeTo = ["FmlmSearchStep"];
          this.next();
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<IFavoriteFmlmLocationActionParams, void>({
        eventName: fmlmSearchTree.Favourite.Location.Click,
        handler: async (payload) => {
          favouriteFmlmLocationAction.setParams({
            userData: payload.data?.userData!,
            locationState: payload.data?.locationState!,
            selectedExactLocation: payload.data?.selectedExactLocation!,
            intl: payload.data?.intl!,
          });
          await favouriteFmlmLocationAction.execute();
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<IConfirmFmlmSearchActionParams, void>({
        eventName: fmlmSearchTree.ConfirmFmlmSearch.Click,
        handler: async (payload) => {
          confirmFmlmSearchAction.setParams({
            search: payload.data?.search!,
            locationData: payload.data?.locationData!,
            visible: payload.data?.visible!,
            selectedExactLocation: payload.data?.selectedExactLocation!,
            isFromPopUp: payload.data?.isFromPopUp || false,
          });
          await confirmFmlmSearchAction.execute();

          let context = this.getCtx<SearchContext>("searchContext")!;
          if (payload.data?.selectedExactLocation === "origin") context.isOriginSelected = true;
           let nextStep = payload.data?.selectedExactLocation === "destination" ? "SearchStartupInit_Step" : "SelectSearchStop_Step";
          context.routeTo = [nextStep];
          this.next();
        },
      })
    );
  }

  async onExecute(): Promise<void> { }
}

export const SelectSearchLocationStepDeclaration = new StepDefinition({
  stepName: "SelectSearchStop_Step",
  stepClass: SelectSearchStopStep,
});
